<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <popup-share-tip />
  </div>
</template>

<script>
import { SET_VISIBLE_TOP } from '@/store/mutationTypes';
import PopupShareTip from './components/PopupShareTip.vue';

export default {
  components: { PopupShareTip },
  name: 'App',
  computed: {
    cachedViews() {
      return this.$route.matched.filter((item) => item.meta.keepAlive).map((item) => item.name);
    },
  },
  async mounted() {
    // 解决ios不支持按钮:active伪类的方法
    document.body.addEventListener('touchstart', () => {});

    // 解决安卓部分机型点击键盘确定按钮无法收起键盘bug
    if (!this.isApple) {
      document.addEventListener('keydown', function (event) {
        console.log(event.keyCode);
        if (event.keyCode === 13) {
          document.activeElement.blur();
        }
      });
    }

    // document.addEventListener('touchstart', (event) => {
    //   if (event.touches.length > 1) {
    //     event.preventDefault();
    //   }
    // });
    // document.addEventListener('gesturestart', (event) => {
    //   event.preventDefault();
    // });

    // 解决ios输入表单被键盘顶上后无法恢复的问题
    if (this.isApple) {
      let oldScrollTop = 0;
      let isFocus = false; // 防止输入框之前切换时界面上下滚动
      const handleFocus = (e) => {
        isFocus = true;
        // e.target.scrollIntoView({ behavior: 'smooth' });
        if (/^\/invoice/.test(this.$route.path)) {
          setTimeout(() => {
            // console.log('focus');
            oldScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            isFocus = false;
          }, 100);
          console.log('invoice', /^\/invoice/.test(this.$route.path), this.$route.path);
          if (['INPUT', 'TEXTAREA'].some((val) => val === e.target.tagName)) {
            console.log('showNavigationBar', window.zeeho.existFunction('showNavigationBar'));
            window.zeeho.showNavigationBar();
            this.$store.commit(SET_VISIBLE_TOP, false);
          }
        }
      };
      const handleBlur = () => {
        console.log(oldScrollTop, document.documentElement.scrollTop || document.body.scrollTop);
        setTimeout(() => {
          if (isFocus) return;
          if (/^\/invoice/.test(this.$route.path)) {
            console.log('hideNavigationBar', window.zeeho.existFunction('hideNavigationBar'));
            window.zeeho.hideNavigationBar();
            this.$store.commit(SET_VISIBLE_TOP, true);
          }
        }, 50);
      };
      document.addEventListener('focus', handleFocus, true);
      document.addEventListener('blur', handleBlur, true);
    }

    function fnResize() {
      const deviceWidth = document.documentElement.clientWidth || window.innerWidth;

      document.documentElement.style.fontSize = `${deviceWidth / 30}px`;
    }
    fnResize();
    window.onresize = () => {
      fnResize();
    };
  },
  watch: {
    $route: {
      deep: true,
      handler(newValue) {
        const meta = newValue.meta || {};
        // window.zeeho.hideNavigationBar();
        this.$store.commit(SET_VISIBLE_TOP, true);
        this.addCounter();
        if (!meta.visibleAudio) {
          window.audio.pause();
        } else {
          // window.audio.src = this.stateAudio.src;
          // window.audio.src = `http://oss-cfmoto.zeehoev.com/codes/cfmoto-h5/music.mp3?t=${new Date().getTime()}`;
          // window.audio.loop = true;
          // window.audio.play();
        }
      },
    },
  },
};
</script>

<style>
.body {
  overflow: hidden;
}
#app {
  height: 100%;
}

/* img::after {
  content: '';
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: url('./assets/images/tiezi_zhanweitu@3x.png') no-repeat center;
  background-size: 100%;
} */
img {
  position: relative;
  object-fit: cover;
}
*::-webkit-media-controls-panel {
  overflow: visible;
}
*::-webkit-media-controls-play-button {
  display: none !important;
}

*::-webkit-media-controls-time-remaining-display {
  display: none;
}
*::-webkit-media-controls-current-time-display {
  display: none;
}
*::-webkit-media-controls-timelinen {
  display: none !important;
  padding: 0;
}

*::-webkit-media-controls-start-playback-button {
  display: block !important;
  -webkit-appearance: red;
}
video {
  background: #000;
}

video::-webkit-progress-bar {
  background: red !important;
}
video::-webkit-progress-inner-element {
  background: red !important;
  display: none;
}
video::-webkit-media-controls {
  overflow: visible !important;
  position: relative;
  z-index: 1000;
  opacity: 0.8;
}
*::-webkit-media-controls-timeline {
  margin-bottom: 0px;
  padding-bottom: 4px;
  padding-top: 4px;
  margin-top: -20px;
  width: calc(100% - 90px);
  display: none;
}
*::-webkit-internal-track-segment-background {
  display: none;
}
*::-webkit-media-controls-mute-button {
  display: none;
}
*::-webkit-media-controls-play-button {
  display: none !important;
}
*::-webkit-media-controls-fullscreen-button {
  background-image: url('./assets/images/full.png');
  opacity: 0.8;
}
video::-internal-media-controls-button-panel {
  overflow: visible !important;
}
</style>
